import React, { CSSProperties } from 'react';
import { Portal } from '../Portal';

interface Props {
  children: React.ReactElement | Array<React.ReactElement>;
  contentStyles?: CSSProperties;
  modalStyles?: CSSProperties;
  name?: string;
  id?: string;
  onClose: () => void;
}

function Notification({
  children,
  contentStyles = {},
  modalStyles = {},
  name,
  id,
  onClose
}: Props): React.ReactElement {
  return (
    <Portal htmlId="wysiwyg-editor-portal" style={{ zIndex: 10000 }}>
      <div
        className="c-modal-container"
        data-modal-name={name}
        style={{ display: 'block' }}
      >
        <div className="c-modal-background" tabIndex={-1} />
        <div
          className="c-modal"
          id={id}
          tabIndex={0}
          role="dialog"
          aria-labelledby="c-modal-headline"
          aria-describedby="c-modal-text"
          style={{ maxWidth: '60rem', ...modalStyles }}
        >
          <div role="document" style={contentStyles}>
            {children}
          </div>

          <div className="c-modal-actions">
            <button
              className="c-modal-actions-cta--single"
              data-action-type="proceed"
              type="button"
              onClick={onClose}
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </Portal>
  );
}

export default Notification;
